<div class="sopo-popup-inner-container">
  <span class="sopo-popup-title">{{ header }}</span>
  <span class="sopo-popup-checkbox">
      <ion-checkbox checked="false" color="success" (ionChange)="dontShow($event)"></ion-checkbox>
      <ion-label>Remember Me</ion-label>
  </span>
  <div class="sopo-popup-button-container">
    <span class="sopo-popup-green-button clickable" (click)="allow()">{{allowText}}</span>
    <span class="sopo-popup-green-button clickable" (click)="continue()">{{continueText}}</span>
    <span class="sopo-popup-red-button clickable" (click)="deny()">{{denyText}}</span>
  </div>
</div>